import { render, staticRenderFns } from "./ClicHintInterno.vue?vue&type=template&id=367b4979&"
import script from "./ClicHintInterno.vue?vue&type=script&lang=js&"
export * from "./ClicHintInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports